const Modal = {
  updated() {
    if (this.el.dataset?.shouldShow === "true") {
      liveSocket.execJS(this.el, this.el.getAttribute("data-show-command"));
    }
    if (this.el.dataset?.shouldShow === "false") {
      liveSocket.execJS(this.el, this.el.getAttribute("data-cancel"));
    }
  },
};

export default Modal;
